import { apiCall, createQueryString } from "../imports"

export default {

    getProvinces() {
        return apiCall('get', "management/provinces")
    },

    getCities(stateID) {
        return apiCall('get', `management/provinces/${stateID}/cities`)
    },

    getAllCities(filters) {
        return apiCall('post', `management/provinces/cities`, filters)
    },

    getDitricts(filters) {
        return apiCall('post', `management/districts/list`,filters)
    },

    createDitricts(data) {
        return apiCall('post', `management/districts`, data)
    },

    updateDitricts(id, data) {
        return apiCall('patch', `management/districts/${id}`, data)
    },

    deleteDitricts(slideId) {
        return apiCall('delete', `management/districts/${slideId}`)
    }
}